import React, {useState} from 'react';
import { useTranslation } from "react-i18next";
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import FastfoodIcon from '@mui/icons-material/Fastfood';
import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';
import TwoWheelerIcon from '@mui/icons-material/TwoWheeler';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import DayJS from 'react-dayjs';
import NumberFormat from 'react-number-format';
import DeliveryView from "../Location/DeliveryView";
import FoodOrderItems from '../FoodOrderItems';
import MoneyDialog from '../MoneyDialog';
import {getTextI18n} from "../TextI18n";

const useStyles = makeStyles({
    root: {},
    cardHeader: {
        borderBottom: '1px solid #a8a8a8'
    }
});

export default function FoodOrderTimeLine({value, reload}) {
    const { t } = useTranslation();
    const history = useHistory();
    const [open, setOpen] = useState(false);
    const classes = useStyles();
    console.log('[FoodOrderTimeLine]');

    const handleBlack = () => {
        history.push('/orders');
    };

    const handleFinishOrder = () => {
        setOpen(true);
    };

    const handleCloseDialog = (value) => {
        setOpen(false);
        if(value){
            reload();
        }
    };

    const CardOrder = ({item}) =>(
        <Box mb={1}>
            <>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="body1">
                        {t('order.number')}
                    </Typography>
                    <Typography variant="h6">
                        <strong>{item.orderNo}</strong>
                    </Typography>
                </Box>
                <Grid container spacing={1}>
                    <Grid item xs={12} md={12}>
                        <Card variant="outlined">
                            <List className={classes.root}>
                                <ListItem>
                                    <ListItemAvatar onClick={e=>handleBlack()}>
                                        <Avatar variant="square" aria-label="picture" src={
                                            item._account.image?
                                                `${process.env.REACT_APP_CDN_BASE_URL}/public/s/${item._account.image.name}`: 'data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw=='
                                        }>
                                        </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText primary={getTextI18n(item._account.name)} secondary={<>{t('shop.tel')}<a href={`tel:${item._account.phone}`}><NumberFormat value={item._account.phone} displayType={'text'} format="###-###-####" /></a></>} />
                                </ListItem>
                            </List>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <Box display="flex" justifyContent="center">
                            <FoodOrderItems value={item}></FoodOrderItems>
                        </Box>
                    </Grid>
                    {item.deliver === 'DELIVERY' &&
                    <Grid item xs={12} md={12}>
                        <DeliveryView shop={item._account} location={item.location} />
                    </Grid>
                    }
                    {item.status !== 'cancel' &&
                    <Grid item xs={12} md={12}>
                        <Card variant="outlined">
                            <CardContent>
                                <Box display="flex" justifyContent="center">
                                    <Typography variant="h6" component="div">
                                        {t('order.state')}
                                    </Typography>
                                </Box>
                                <Timeline position="alternate">
                                    <TimelineItem>
                                        {item.timeLine.orders &&
                                        <TimelineOppositeContent
                                            color={item.timeLine.step === 1 ? "text.primary" : "text.secondary"}>
                                            <DayJS format="HH:mm">{item.timeLine.orders}</DayJS>
                                        </TimelineOppositeContent>
                                        }
                                        <TimelineSeparator>
                                            <TimelineDot color="primary"><AssignmentTurnedInIcon/></TimelineDot>
                                            <TimelineConnector style={{height: '22px'}}/>
                                        </TimelineSeparator>
                                        <TimelineContent
                                            color="text.secondary">{t('order.orders')}</TimelineContent>
                                    </TimelineItem>
                                    <TimelineItem>
                                        {item.timeLine.cooking &&
                                        <TimelineOppositeContent
                                            color={item.timeLine.step === 2 ? "text.primary" : "text.secondary"}>
                                            <DayJS format="HH:mm">{item.timeLine.cooking}</DayJS>
                                        </TimelineOppositeContent>
                                        }
                                        <TimelineSeparator>
                                            <TimelineDot
                                                color={item.timeLine.cooking ? "primary" : "grey"}><FastfoodIcon/></TimelineDot>
                                            <TimelineConnector style={{height: '22px'}}/>
                                        </TimelineSeparator>
                                        <TimelineContent
                                            color="text.secondary">{t('order.cooking')}</TimelineContent>
                                    </TimelineItem>
                                    {item.deliver === 'DELIVERY' &&
                                    <TimelineItem>
                                        {item.timeLine.delivering &&
                                        <TimelineOppositeContent
                                            color={item.timeLine.step === 3 ? "text.primary" : "text.secondary"}>
                                            <DayJS format="HH:mm">{item.timeLine.delivering}</DayJS>
                                        </TimelineOppositeContent>
                                        }
                                        <TimelineSeparator>
                                            <TimelineDot
                                                color={item.timeLine.delivering ? "primary" : "grey"}><TwoWheelerIcon/></TimelineDot>
                                            <TimelineConnector style={{height: '22px'}}/>
                                        </TimelineSeparator>
                                        <TimelineContent
                                            color="text.secondary">{t('order.delivering')}</TimelineContent>
                                    </TimelineItem>
                                    }
                                    {item.deliver === 'PICKUP' &&
                                    <TimelineItem>
                                        {item.timeLine.delivering &&
                                        <TimelineOppositeContent
                                            color={item.timeLine.step === 3 ? "text.primary" : "text.secondary"}>
                                            <DayJS format="HH:mm">{item.timeLine.delivering}</DayJS>
                                        </TimelineOppositeContent>
                                        }
                                        <TimelineSeparator>
                                            <TimelineDot
                                                color={item.timeLine.delivering ? "primary" : "grey"}><DoneAllIcon/></TimelineDot>
                                            <TimelineConnector style={{height: '22px'}}/>
                                        </TimelineSeparator>
                                        <TimelineContent
                                            color="text.secondary">{t('order.prepared')}</TimelineContent>
                                    </TimelineItem>
                                    }
                                    <TimelineItem>
                                        {item.timeLine.received &&
                                        <TimelineOppositeContent
                                            color={item.timeLine.step === 4 ? "text.primary" : "text.secondary"}>
                                            <DayJS format="HH:mm">{item.timeLine.received}</DayJS>
                                        </TimelineOppositeContent>
                                        }
                                        <TimelineSeparator>
                                            <TimelineDot
                                                color={item.timeLine.received ? "primary" : "grey"}><SentimentVerySatisfiedIcon/></TimelineDot>
                                        </TimelineSeparator>
                                        <TimelineContent
                                            color="text.secondary">{t('order.received')}</TimelineContent>
                                    </TimelineItem>
                                </Timeline>
                                {item.status !== 'received' &&
                                <Box>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="large"
                                        disableElevation
                                        onClick={e=>handleFinishOrder()}
                                        fullWidth={true}
                                        startIcon={<SentimentVerySatisfiedIcon />}
                                    >
                                        {t('order.finishedDelivery')}
                                    </Button>
                                </Box>
                                }
                            </CardContent>
                        </Card>
                    </Grid>
                    }
                </Grid>
            </>
        </Box>
    );

    return (
        <Box>
            <CardOrder item={value} />
            <MoneyDialog value={value} open={open} onClose={handleCloseDialog} />
        </Box>
    )
};